import React from 'react';
import classNames from "classnames";
import Icon from 'components/icons/icon';
import Text from 'components/text/text';

export default function Badge(props) {
  const fillColor = props.fillColor ? props.fillColor : 'DefaultGray';
  const strokeColor = props.strokeColor ? props.strokeColor : '';
  const badgeIconClasses = classNames(
    'badge-icon',
    {
      [`mix-badge-icon_color${props.badgeColor}`]: props.badgeColor
    }
  )
  const label = !props.label ? '' : (
    <div className="badge-label">
      <Text className="mix-txt_uppercase" color="DefaultGray" weight="light">
        {props.label}
      </Text>
    </div>
  );

  return (
    <div className="badge">
      <div className={badgeIconClasses}>
        <Icon
          fillColor={fillColor}
          strokeColor={strokeColor}
          iconType={props.icon}
          iconSize={props.size}
        />
      </div>
      {label}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/client/components/badge.jsx